// This file is generated by pnpm icons:generate. Do not edit.

import {SquareArrowTopRight_Stroke2_Corner0_Rounded as CanonicalSquareArrowTopRight_Stroke2_Corner0_Rounded} from './Square'

/** @deprecated Import SquareArrowTopRight_Stroke2_Corner0_Rounded from `#/components/icons/Square` instead. */
export const SquareArrowTopRight_Stroke2_Corner0_Rounded =
  CanonicalSquareArrowTopRight_Stroke2_Corner0_Rounded
